import React from "react";

const InvalidateInterviewEmail = ({ exampleEmail }) => {
  if (!exampleEmail) {
    return <div />;
  }
  return <div dangerouslySetInnerHTML={exampleEmail} />;
};

export default InvalidateInterviewEmail;
